export const getApiCallsUrl = () => {
    if(process.env.REACT_APP_IS_LOCAL === 'true') {
        return process.env.REACT_APP_LOCAL_STRAPI_URL;
    }
    return process.env.REACT_APP_STRAPI_URL;
}
/*ngrok start --all --config .ngrok2.yml*/
export const getMediaCallsUrl = () => {
    if(process.env.REACT_APP_IS_LOCAL === 'true') {
        return process.env.REACT_APP_LOCAL_STRAPI_MEDIA_URL;
    }
    return  process.env.REACT_APP_STRAPI_MEDIA_URL;
}
